/**
 * Datadog RUM action emitted for every Copilot SSE cancellation. Grouping
 * production cancellations by reason is how we distinguish a user-initiated
 * abort (Stop button, new session, tab close) from an infra-initiated drop
 * (ALB / CloudFront idle timeout, upstream stream error).
 */
export const COPILOT_SSE_CANCEL_ACTION = "copilot.sse.cancel";
